import { VERCEL_UI_MESSAGE_STREAM_HEADER, VERCEL_UI_MESSAGE_STREAM_VERSION } from "./streamHeaders";

const CLIENT_VERSION_HEADER = "x-sudowrite-client-version";

export function getAgenticStreamVersionHeader(): Record<string, string> {
  if (typeof window === "undefined") return {};
  const version = (window as { sudowriteClientVersion?: string }).sudowriteClientVersion
    ?? (window as { sudowriteVersion?: string }).sudowriteVersion;
  return version ? { [CLIENT_VERSION_HEADER]: version } : {};
}

/** Match Auth.js dev bypass: localhost pages hit REACT_APP_API_HOST directly. */
export function bypassAgenticStreamProxyInDev(url: string): string {
  if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
    const hostname = window.location?.hostname;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
    if (isLocalhost && url?.[0] === "/") {
      const apiHost = process.env.REACT_APP_API_HOST || "http://localhost:5000";
      return apiHost + url;
    }
  }
  if (typeof window !== "undefined") {
    const { hostname } = window.location;
    if ((hostname === "localhost" || hostname === "127.0.0.1") && !url.startsWith("http")) {
      return url;
    }
  }
  return url;
}

export function agenticStreamRequestHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    ...getAgenticStreamVersionHeader(),
    [VERCEL_UI_MESSAGE_STREAM_HEADER]: VERCEL_UI_MESSAGE_STREAM_VERSION,
  };
}
